<template>
    <v-dialog v-model="visible" width="800">
        <template #activator="{}">
            <v-btn color="primary" @click="open">
                {{ $t('einstellungen.dialog.button') }}
            </v-btn>
        </template>
        <Form ref="observer" v-slot="{ meta }">
            <form @submit.prevent="submit">
                <v-card>
                    <FocusLock>
                        <v-card-title class="headline font-weight-bold">
                            {{ $t('einstellungen.funktion.dialog.title') }}
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pb-0">
                            <h2 class="font-weight-bold">
                                {{ $t('einstellungen.funktion.dialog.title.lieferantenrechnung') }}
                            </h2>
                            <v-col sm="12" class="pt-3 pb-0 multiline-checkbox">
                                <v-checkbox v-model="teilnehmerFunktionApiDtoCopy.hatRechnungenNurViaVetdata" :hide-details="true">
                                    <template #label>
                                        <div>
                                            <b>
                                                {{ $t('einstellungen.funktion.dialog.verzichtpostszustellunglieferantenrechnung') }}
                                            </b>
                                            <br />
                                            <div>
                                                {{ $t('einstellungen.funktion.dialog.verzichtpostszustellunglieferantenrechnung.hinweis') }}
                                            </div>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <v-col sm="12" class="pt-0 multiline-checkbox">
                                <v-checkbox
                                    v-model="emailSendenLieferantRechnung"
                                    :hide-details="true"
                                    @change="checkboxLieferantenrechnungenUpdated($event.target.checked)"
                                >
                                    <template #label>
                                        {{ $t('einstellungen.funktion.dialog.zustellungemaillieferantenrechnung') }}
                                    </template>
                                </v-checkbox>
                                <Field
                                    v-slot="{ errors, field }"
                                    v-model="teilnehmerFunktionApiDtoCopy.emailLieferantRechnung"
                                    name="LieferantenEmail"
                                    :rules="getValidation('teilnehmerFunktionApiDto.emailLieferantRechnung') + '|' + emailLieferantRechnungenValidation"
                                >
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmerFunktionApiDtoCopy.emailLieferantRechnung"
                                        :disabled="!emailSendenLieferantRechnung"
                                        :label="$t('einstellungen.funktion.dialog.emaillieferantenrechnung') + '*'"
                                        placeholder="..."
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                            </v-col>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-text class="pb-0">
                            <h2 class="font-weight-bold">
                                {{ $t('einstellungen.funktion.dialog.title.tvsdokumente') }}
                            </h2>

                            <v-col sm="12" class="pt-3 pb-0 multiline-checkbox">
                                <v-checkbox v-model="teilnehmerFunktionApiDtoCopy.hatTvsDokumenteNurDigital" :hide-details="true">
                                    <template #label>
                                        <div>
                                            <b>
                                                {{ $t('einstellungen.funktion.dialog.zustellunglieferantenrechnung') }}
                                            </b>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <!-- NEW PART -->
                            <v-col sm="12" class="pt-0 multiline-checkbox">
                                <v-checkbox v-model="emailSendenTvsDokument" :hide-details="true" @change="checkboxTvsDokumenteUpdated($event.target.checked)">
                                    <template #label>
                                        <div>
                                            <b>
                                                {{ $t('einstellungen.funktion.dialog.zustellungemailtvsdokumente') }}
                                            </b>
                                            <br />
                                            <div>
                                                {{ $t('einstellungen.funktion.dialog.zustellungemailtvsdokumente.hinweis') }}
                                            </div>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <Field
                                    v-slot="{ errors, field }"
                                    v-model="teilnehmerFunktionApiDtoCopy.emailTvsDokument"
                                    name="TvsDokumenteEmail"
                                    :rules="getValidation('teilnehmerFunktionApiDto.emailTvsDokument') + '|' + emailTvsDokumentValidation"
                                >
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmerFunktionApiDtoCopy.emailTvsDokument"
                                        :disabled="!emailSendenTvsDokument"
                                        :label="$t('einstellungen.funktion.dialog.emailtvsdokumente') + '*'"
                                        placeholder="..."
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                            </v-col>
                        </v-card-text>
                        <!-- NEW PART  FINISHED-->
                        <v-divider></v-divider>
                        <v-card-actions class="ml-4 pt-4">
                            <v-btn :disabled="!meta.valid" color="primary" variant="flat" type="submit" class="modalbutton mb-3">
                                {{ $t('components.dialog.save') }}
                            </v-btn>
                            <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false">
                                {{ $t('components.dialog.cancel') }}
                            </v-btn>
                        </v-card-actions>
                    </FocusLock>
                </v-card>
            </form>
        </Form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

import { namespace } from 'vuex-facing-decorator';

import { Form, Field } from 'vee-validate';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
const profilModul = namespace(NAME_EINSTELLUNGEN);

import { NAME as NAME_VALIDATION } from '@/store/modules/validation';
const validationModul = namespace(NAME_VALIDATION);

import { EDIT_TEILNEHMERFUNKTION } from '../store/actions';
import { GET_VALIDATION_KEY } from '@/store/modules/validation/getters';
import { TeilnehmerFunktionApiDto } from '@/api-schema';
@Component({
    components: {
        Form,
        Field
    }
})
export default class EditFunktionenDialog extends Vue {
    @Prop({ required: true, type: Object })
    teilnehmerFunktionApiDto!: TeilnehmerFunktionApiDto | null;
    visible = false;
    teilnehmerFunktionApiDtoCopy: TeilnehmerFunktionApiDto;
    emailSendenLieferantRechnung = false;
    emailSendenTvsDokument = false;
    @profilModul.Action(EDIT_TEILNEHMERFUNKTION) edit!: Function;
    @validationModul.Getter(GET_VALIDATION_KEY) getValidation!: (key: string) => string;

    onSave() {
        this.edit(this.teilnehmerFunktionApiDtoCopy).then(() => {
            this.visible = false;
        });
    }

    get emailLieferantRechnungenValidation() {
        return this.emailSendenLieferantRechnung ? 'required' : '';
    }
    get emailTvsDokumentValidation() {
        return this.emailSendenTvsDokument ? 'required' : '';
    }
    submit() {
        this.edit(this.teilnehmerFunktionApiDtoCopy).then(() => {
            this.visible = false;
        });
    }

    open() {
        this.teilnehmerFunktionApiDtoCopy = Object.assign({}, this.teilnehmerFunktionApiDto);
        this.emailSendenLieferantRechnung = this.teilnehmerFunktionApiDto.emailLieferantRechnung?.length > 0;
        this.emailSendenTvsDokument = this.teilnehmerFunktionApiDto.emailTvsDokument?.length > 0;

        this.visible = true;
    }

    checkboxLieferantenrechnungenUpdated(newValue: boolean) {
        if (!newValue) {
            this.teilnehmerFunktionApiDtoCopy.emailLieferantRechnung = null;
        }
    }
    checkboxTvsDokumenteUpdated(newValue: boolean) {
        if (!newValue) {
            this.teilnehmerFunktionApiDtoCopy.emailTvsDokument = null;
        }
    }
}
</script>

<style>
.multiline-checkbox .v-input--selection-controls .v-input__slot > .v-label {
    display: block;
}
</style>
